module.exports = __webpack_public_path__ + "img/u8.b9e93835.svg";